import { render, staticRenderFns } from "./PdfProductTable.vue?vue&type=template&id=02badeb1&"
import script from "./PdfProductTable.vue?vue&type=script&lang=js&"
export * from "./PdfProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports